import React, { useId } from 'react';

const FormInput = ({ label, type, placeholder, required, value, min, max, autoComplete, step, onChange }) => {
  const id = useId();
  const isRequired = required && 'required';

  return (
    <div className="w-full relative px-3 py-3 border border-gray-300 rounded-md shadow-sm -space-y-px bg-white">
      <label htmlFor={id} className="block font-bold text-xs">
        {label} <span className="text-gray-600 font-normal">{required ? '*' : '(optional)'}</span>
      </label>
      <input
        id={id}
        name={id}
        type={type || 'text'}
        step={step || 1}
        className="w-full appearance-none placeholder-gray-500 text-gray-900 focus:outline-none focus:fill-transparent focus:z-10 sm:text-sm"
        placeholder={placeholder}
        value={value}
        min={min}
        max={max}
        autoComplete={autoComplete}
        onChange={e => onChange(e.target.value)}
        required={isRequired}
      />
    </div>
  );
};

export default FormInput;
